/**
 * @generated SignedSource<<6ddb40eeddafd7427b4beba71926f13d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserEventInput = {
  id: number;
};
export type MenuOptionsSidebarRecordUpdatesClicked_Mutation$variables = {
  input: UserEventInput;
};
export type MenuOptionsSidebarRecordUpdatesClicked_Mutation$data = {
  readonly recordUpdatesClicked: {
    readonly success: boolean;
  };
};
export type MenuOptionsSidebarRecordUpdatesClicked_Mutation = {
  response: MenuOptionsSidebarRecordUpdatesClicked_Mutation$data;
  variables: MenuOptionsSidebarRecordUpdatesClicked_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuccessOutput",
    "kind": "LinkedField",
    "name": "recordUpdatesClicked",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MenuOptionsSidebarRecordUpdatesClicked_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MenuOptionsSidebarRecordUpdatesClicked_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef454026303c43b77ff73283679913fa",
    "id": null,
    "metadata": {},
    "name": "MenuOptionsSidebarRecordUpdatesClicked_Mutation",
    "operationKind": "mutation",
    "text": "mutation MenuOptionsSidebarRecordUpdatesClicked_Mutation(\n  $input: UserEventInput!\n) {\n  recordUpdatesClicked(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a0fbbde55cc5ba966a13f94de00e30a";

export default node;
